var React = require('react');

function Flame (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M8.735 8.147c1.412-2.09 0-4.941-.706-5.647 0 2.144-1.251 3.347-2.117 4.235-.866.89-1.412 2.287-1.412 3.53a4.235 4.235 0 0 0 8.47 0c0-1.082-.745-2.781-1.411-3.53-1.26 2.118-1.97 2.118-2.824 1.412Z","stroke":"currentColor","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","transform":"translate(.5 .5)","d":"M0 0h16v16H0z"})))]);
}

Flame.defaultProps = {"viewBox":"0 0 17 17","fill":"none"};

module.exports = Flame;

Flame.default = Flame;
